import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { LicenceDataModel } from 'src/app/models/lic-list.model';
import { HttpFunctionsService } from 'src/app/services/http-services/http-functions.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { LicenseSlug } from 'src/app/models/selected-files-data';
@Injectable({
  providedIn: 'root'
})
export class LicenseService implements Resolve<any> {

  constructor(private httpMethods: HttpFunctionsService,
    private sessionService: BrowserStorageService) { }

    resolve(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<Array<LicenceDataModel>>|Promise<Array<LicenceDataModel>>| Array<LicenceDataModel> {
      return this.getLicence()
    }

  /**
   * Get Licence Data
   * @returns
   */
  getLicence(): Observable<Array<LicenceDataModel>> {
      const cached = this.sessionService.getLicData();
      // Use the cache only when it is populated AND already contains the latest
      // licenses (e.g. the MP3 lease). This avoids serving a stale list from
      // browser storage that predates a newly added license, while still
      // preventing an API call on every navigation once the list is current.
      if (cached.length > 0 && cached.some((lic: LicenceDataModel) => lic.slug === LicenseSlug.Mp3)) {
          return of(cached);
      }
      return this.httpMethods.getMethod('licence/list').pipe(
        map((response: any) => {
          let liceData: Array<LicenceDataModel> = [];
          if (response.data &&  response.data.length) {
            liceData =  response.data;
            this.sessionService.setLicData(liceData)
          }
          return liceData;
        }),
        catchError((error) => {
          return throwError(error);
        })
      )
  }
}
